export async function acceso(token){
    console.log(token)
    let configuraciones = JSON.parse(window.localStorage.getItem('ConfiguracionGeneral'))
    let reqext = await fetch(`${configuraciones.ServidorDicom}/visorexterno/${token}`)
    let resext = await reqext.json()
    return(resext)
}